import { ReactNode } from 'react'

import { Input, Space } from 'antd'
import { useTheme } from 'antd-style'

import { nzh } from '@eastcoal/common/utils/nzh'

import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { SplitValueRankingInputProps, SplitValuesInputProps } from './interface'

const RankingInput = ({
  index,
  addonAfter,
  disabled,
  value,
  onChange
}: SplitValueRankingInputProps) => {
  const theme = useTheme()
  const rankingText = `第${nzh.encodeS(index)}名`
  return (
    <Space.Compact style={{ width: '100%' }}>
      <span>{rankingText}</span>
      <Input
        disabled={disabled}
        value={value}
        styles={{
          input: {
            borderColor: disabled ? `${theme.colorBorder}` : undefined
          }
        }}
        onChange={e => {
          onChange(Number(e.target.value))
        }}
      />
      {addonAfter && <span>{addonAfter}</span>}
    </Space.Compact>
  )
}

const Component = ({
  dealCount = 0,
  maxDealCount = 0,
  unit,
  disabled,
  value = [],
  onChange
}: SplitValuesInputProps) => {
  const inputNodes: ReactNode[] = []

  for (let i = 0; i < maxDealCount; i++) {
    const rankingIndex = i + 1
    const isDirty = rankingIndex > dealCount
    inputNodes.push(
      <RankingInput
        key={i}
        addonAfter={unit}
        disabled={disabled || isDirty}
        index={rankingIndex}
        value={value[i]}
        onChange={rankingValue => {
          const newValue = [...value]
          newValue[i] = rankingValue
          onChange?.(newValue)
        }}
      />
    )
  }

  return (
    <Space
      style={{ width: '100%' }}
      styles={{
        item: {
          flex: 1
        }
      }}
    >
      {inputNodes}
    </Space>
  )
}

export const SplitValuesInput = connect(
  Component,
  mapReadPretty(Component, {
    disabled: true
  })
)
